export * from './useResponsiveAkamaiTemplate';
